import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const quickLinks = [
    { to: '/', label: t('footer.links.home') },
    { to: '/about', label: t('footer.links.about') },
    { to: '/notices', label: t('footer.links.notices') },
    { to: '/videos', label: t('footer.links.videos') },
    { to: '/galleries', label: t('footer.links.galleries') },
    { to: '/events', label: t('footer.links.events') },
    { to: '/contact', label: t('footer.links.contact') },
  ];

  const serviceLinks = [
    { to: '/resident', label: t('footer.links.residentPortal') },
    { to: '/manager', label: t('footer.links.managerPanel') },
    { to: '/admin', label: t('footer.links.adminPanel') },
    { to: '/bills', label: t('footer.links.billPayment') },
    { to: '/complaints', label: t('footer.links.complaintSystem') },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px' }}>
              <img 
                src="/logo.png" 
                alt={t('app.name')} 
                style={{
                              
                  height: '100px',  
                  width: 'auto',
                  objectFit: 'contain',
                  background: 'white',
                  padding: '0px',
                  borderRadius: '50px',
                  boxShadow: 'rgba(0, 0, 0, 0.15) 0px 2px 6px',
                }}
              />
              <h3 style={{ margin: 0, color: '#f7f7f7' }}>{t('app.name')}</h3>
            </div>
            <p>{t('footer.description')}</p>
            <div className="social-links">
              <a href="#" className="social-link" aria-label="Facebook">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="#" className="social-link" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="social-link" aria-label="LinkedIn">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="#" className="social-link" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>{t('footer.quickLinks')}</h4>
            <ul className="footer-links">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h4>{t('footer.services')}</h4>
            <ul className="footer-links">
              {serviceLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h4>{t('footer.contact')}</h4>
            <div className="contact-info">
              <div className="contact-item">
                <i className="fas fa-map-marker-alt"></i>
                <span>{t('footer.contactDetails.address')}</span>
              </div>
              <div className="contact-item">
                <i className="fas fa-phone"></i>
                <span>{t('footer.contactDetails.phone')}</span>
              </div>
              <div className="contact-item">
                <i className="fas fa-envelope"></i>
                <span>{t('footer.contactDetails.email')}</span>
              </div>
              <div className="contact-item">
                <i className="fas fa-clock"></i>
                <span>{t('footer.contactDetails.support')}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>{t('footer.copyright', { year })}</p>
            </div>
            <div className="developer-info">
              <p>
                {t('footer.developedBy')}{' '}
                <a 
                  href="https://ainixit.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="developer-link"
                >
                  Ainix IT
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
